import { z } from 'zod';

const CustomerSchema = z
  .strictObject({
    isCompany: z.boolean(),
    customerName: z.string().optional(),
    titlePrefix: z.string().optional(),
    firstName: z.string().nonempty({ message: 'Validation.FirstName.NotEmpty' }),
    lastName: z.string().nonempty({ message: 'Validation.LastName.NotEmpty' }),
    titleSuffix: z.string().optional(),
    registrationNumber: z.string().optional(),
    vatNumber: z.string().optional(),
    taxNumber: z.string().optional(),
    phoneNumber: z.string().nonempty({ message: 'Validation.PhoneNumber.NotEmpty' }),
    emailAddress: z
      .string()
      .nonempty({ message: 'Validation.EmailAddress.NotEmpty' })
      .email({ message: 'Validation.EmailAddress.InvalidFormat' }),
    billingStreet: z.string().nonempty({ message: 'Validation.Street.NotEmpty' }),
    billingTown: z.string().nonempty({ message: 'Validation.Town.NotEmpty' }),
    billingPostCode: z.string().nonempty({ message: 'Validation.PostCode.NotEmpty' }),
    billingCountryCode: z.string().nonempty({ message: 'Validation.CountryCode.NotEmpty' }),
    differentShipping: z.boolean(),
    shippingAddress: z
      .strictObject({
        addressId: z.string().optional(),
        street: z.string().optional(),
        town: z.string().optional(),
        postCode: z.string().optional(),
        countryCode: z.string().optional(),
      })
      .optional(),
  })
  .superRefine((data, ctx) => {

    // nazov firmy
    if (data.isCompany && !data.customerName) {
      ctx.addIssue({
        code: 'custom',
        path: ['customerName'],
        message: 'Validation.CustomerName.NotEmpty',
      });
    }

    // ico
    if (data.isCompany && !data.registrationNumber) {
      ctx.addIssue({
        code: 'custom',
        path: ['registrationNumber'],
        message: 'Validation.RegistrationNumber.NotEmpty',
      });
    }

    // dodacia adresa
    if (data.differentShipping) {
      if (!data.shippingAddress?.street) {
        ctx.addIssue({
          code: 'custom',
          path: ['shippingAddress.street'],
          message: 'Validation.Street.NotEmpty',
        });
      }

      if (!data.shippingAddress?.town) {
        ctx.addIssue({
          code: 'custom',
          path: ['shippingAddress.town'],
          message: 'Validation.Town.NotEmpty',
        });
      }

      if (!data.shippingAddress?.postCode) {
        ctx.addIssue({
          code: 'custom',
          path: ['shippingAddress.postCode'],
          message: 'Validation.PostCode.NotEmpty',
        });
      }

      if (!data.shippingAddress?.countryCode) {
        ctx.addIssue({
          code: 'custom',
          path: ['shippingAddress.countryCode'],
          message: 'Validation.CountryCode.NotEmpty',
        });
      }
    }
  });

export const CheckoutFormSchema = z.object({
  // Basket
  note: z.string().optional(),
  // Methods
  shippingMethodId: z.string(),
  paymentMethodId: z.string(),
  // Customer
  customer: CustomerSchema,
});

export type CheckoutFormModel = z.infer<typeof CheckoutFormSchema>;
